import { Timestamp } from 'firebase/firestore';

export const getChatActivityTimestamp = (chat) => {
  if (chat?.lastMessageTimestamp) {
    const t = chat.lastMessageTimestamp;
    if (t instanceof Timestamp) return t.toDate().getTime();
    if (typeof t === 'number') return t;
    const parsed = new Date(t);
    return Number.isNaN(parsed.getTime()) ? 0 : parsed.getTime();
  }

  if (chat?.createdAt) {
    const c = chat.createdAt;
    const d = c instanceof Timestamp ? c.toDate() : new Date(c);
    return Number.isNaN(d.getTime()) ? 0 : d.getTime();
  }

  return 0;
};

export const sortChatsByRecentlyActive = (chats) => {
  return [...chats].sort(
    (a, b) => getChatActivityTimestamp(b) - getChatActivityTimestamp(a)
  );
};
